import React from 'react';
import { observer } from 'mobx-react';
import { extractUnit, extractValue } from '../cssUtils';
import Select from '../../inputs/simpleComponents/Select';
import CssDimensionNumberInput from './baseInputs/CssDimensionNumberInput';
const isCustomValue = value => {
  return !['auto', 'contain', 'cover', 'custom'].includes(value);
};
const BackgroundSizeEdit = observer(({
  value,
  setValue
}) => {
  if (value === 'auto') {
    value = '100% 100%';
  }
  const x_size = isCustomValue(value) ? value.split(' ')[0] : '';
  const y_size = isCustomValue(value) ? value.includes(' ') ? value.split(' ')[1] : x_size : '';
  return /*#__PURE__*/React.createElement("div", {
    className: "single-css-property"
  }, /*#__PURE__*/React.createElement("span", {
    className: "css-property-name"
  }, "Dimensione background"), /*#__PURE__*/React.createElement("span", {
    className: "css-values single-row-css-values"
  }, /*#__PURE__*/React.createElement("span", {
    className: "single-row-css-value"
  }, /*#__PURE__*/React.createElement(Select, {
    elements: [{
      label: 'Contain',
      value: 'contain'
    }, {
      label: 'Cover',
      value: 'cover'
    }, {
      label: 'Personalizzata',
      value: 'custom'
    }],
    defaultValue: isCustomValue(value) ? 'custom' : value,
    onChangeSelect: type => {
      if (type === 'custom') {
        if (!isCustomValue(value)) {
          setValue('100% 100%');
        }
      } else {
        setValue(type);
      }
    }
  })), isCustomValue(value) ? /*#__PURE__*/React.createElement("span", {
    className: "single-row-css-value"
  }, /*#__PURE__*/React.createElement("span", {
    className: "single-css-value single-row-css-value"
  }, /*#__PURE__*/React.createElement(CssDimensionNumberInput, {
    value: extractValue(x_size),
    unit: extractUnit(x_size),
    setValue: (v, unit) => {
      const newValue = `${v}${unit} ${y_size}`;
      setValue(newValue);
    },
    title: 'X'
  })), /*#__PURE__*/React.createElement("span", {
    className: "single-css-value"
  }, /*#__PURE__*/React.createElement(CssDimensionNumberInput, {
    value: extractValue(y_size),
    unit: extractUnit(y_size),
    setValue: (v, unit) => {
      const newValue = `${x_size} ${v}${unit}`;
      setValue(newValue);
    },
    title: 'Y'
  }))) : null));
});
export default BackgroundSizeEdit;